import { EXPIRED_SESSION_KEY } from '../constants/expiredSessionKey';

export const enableExpiredSessionBanner = () => window.sessionStorage.setItem(EXPIRED_SESSION_KEY, 'true');
